import Modal from '../components/Modal';
export var updateVersionModal = function () {
    Modal.confirm({
        modalType: 'whaleProcess',
        title: 'Обновления',
        text: ' В систему внесены обновления, перезагрузите, пожалуйста, страницу',
        okText: 'Перезагрузить',
        cancelText: 'Позже',
        onOk: function () {
            window.location.href = window.location.href;
        },
    });
};
//# sourceMappingURL=updateVersionModal.js.map